import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

export interface PublicProfileBottomSheetData {
  corperSlug: string
}

@Component({
  selector: 'app-public-profile-bottomsheet',
  templateUrl: './public-profile-bottomsheet.component.html',
  styleUrls: ['./public-profile-bottomsheet.component.css']
})
export class PublicProfileBottomsheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: PublicProfileBottomSheetData,
    private bottomSheetRef: MatBottomSheetRef<PublicProfileBottomsheetComponent>,
  ) {}

  close(): void {
    this.bottomSheetRef.dismiss()
  }
}
